<template>
  <div class="panel panel-default">
    <div v-if="showHeader" class="panel-heading">
      <div class="pull-left" style="padding-top: 7px; padding-right: 4px;">
        <status-label :status="partnership.attributes.status"></status-label>
      </div>

      <div class="pull-left">
        <h5>
          Partnership: {{ partnership.attributes.portal_name }}
        </h5>
      </div>

      <div class="clearfix"/>
    </div>

    <loading-spinner v-if="loading"></loading-spinner>

    <div v-else class="panel-body">
      <div class="row" style="margin-bottom: 15px;">
        <div class="col-xs-8 text-center" style="border-right: 1px solid #ddd">
            <span style="font-size: 24px;">
              {{ currentPrice | price }}
            </span>

          <br>

          <span class="text-muted">
              Current Price
            </span>
        </div>

        <div class="col-xs-8 text-center" style="border-right: 1px solid #ddd">
            <span style="font-size: 24px;">
              {{ partnership.attributes.price | price }}
            </span>

          <br>

          <span class="text-muted">
              Future Price
            </span>
        </div>

        <div class="col-xs-8 text-center" style="border-right: 1px solid #ddd">
          <span style="font-size: 24px;">
            {{ partnership.attributes.has_automatic_renewal ? 'Yes' : 'No' }}
          </span>

          <br>

          <span class="text-muted">
            Automatic Renewal
          </span>
        </div>
      </div>

      <hr>

      <div class="row" style="margin-bottom: 15px;">
        <div class="col-xs-8 text-center" style="border-right: 1px solid #ddd">
          <span style="font-size: 24px;">
            <span v-if="!isTrial">
              {{ startsAt | date }}
            </span>

            <span v-else>
              N/A
            </span>
          </span>

          <br>

          <span class="text-muted">
            Starts At
          </span>
        </div>

        <div class="col-xs-8 text-center" style="border-right: 1px solid #ddd">
          <span style="font-size: 24px;">
            <span v-if="!isTrial">
             {{ endsAt | date }}
            </span>

            <span v-else>
              N/A
            </span>
          </span>

          <br>

          <span class="text-muted">
            Ends At
          </span>
        </div>

        <div class="col-xs-8 text-center">
          <span style="font-size: 24px;">
            <span v-if="activity.attributes.latest_content">
              {{ activity.attributes.latest_content | date }}
            </span>

            <span v-else>
              N/A
            </span>
          </span>

          <br>

          <span class="text-muted">
            Latest Content
          </span>
        </div>
      </div>

      <div v-if="partnership.attributes.status !== 'closed'">
        <hr>

        <div class="row" style="margin-bottom: 15px;">
          <div class="col-xs-6 text-center" style="border-right: 1px solid #ddd">
            <span style="font-size: 24px;">
              {{ activity.attributes.article_count }}
            </span>

            <br>

            <span class="text-muted">
              Articles
            </span>
          </div>

          <div class="col-xs-6 text-center" style="border-right: 1px solid #ddd">
            <span style="font-size: 24px;">
              {{ activity.attributes.event_count }}
            </span>

            <br>

            <span class="text-muted">
              Events
            </span>
          </div>

          <div class="col-xs-6 text-center" style="border-right: 1px solid #ddd">
            <span style="font-size: 24px;">
              {{ activity.attributes.file_count }}
            </span>

            <br>

            <span class="text-muted">
              Files
            </span>
          </div>

          <div class="col-xs-6 text-center">
            <span style="font-size: 24px;">
              {{ activity.attributes.job_count }}
            </span>

            <br>

            <span class="text-muted">
              Jobs
            </span>
          </div>
        </div>

        <hr>

        Status:

        <span v-if="partnership.attributes.latest_content_status === 'green'" class="label label-success">
          On track
        </span>

        <span v-if="partnership.attributes.latest_content_status === 'amber'" class="label label-warning">
          At Risk
        </span>

        <span v-if="partnership.attributes.latest_content_status === 'red'" class="label label-danger">
          Off-track
        </span>

        <article-chart :activity="activity"></article-chart>
      </div>

      <div v-if="contentItems.data.length">
        <table class="table table-condensed table-striped">
          <thead>
          <tr>
            <th class="col-xs-8">
              Title
            </th>

            <th class="col-xs-4">
              Type
            </th>

            <th class="col-xs-6">
              Publish At
            </th>

            <th class="col-xs-6">
              Author
            </th>
          </tr>
          </thead>

          <tbody>
          <tr v-for="contentItem in contentItems.data">
            <td class="table__ellipsis">
              <a :href="contentItem.attributes.url" target="_blank">
                {{ contentItem.attributes.title }}
              </a>
            </td>

            <td>
              <span v-if="contentItem.attributes.parent_type === 'content-articles'">
                Article
              </span>

              <span v-else-if="contentItem.attributes.parent_type === 'content-events'">
                Event
              </span>

              <span v-else-if="contentItem.attributes.parent_type === 'content-files'">
                File
              </span>

              <span v-else-if="contentItem.attributes.parent_type === 'content-jobs'">
                Job
              </span>

              <span v-else>
                {{ contentItem.attributes.parent_type }}
              </span>
            </td>

            <td>
              {{ contentItem.attributes.publish_at | datetime }}
            </td>

            <td class="table__ellipsis">
              {{ contentItem.attributes.author_name }}
            </td>
          </tr>

          <tr v-if="!contentItems.data.length">
            <td colspan="4" class="text-center">
              <i>
                There is no content to display.
              </i>
            </td>
          </tr>
          </tbody>
        </table>

        <Pager :pagination="contentItems.meta" @navigate="contentItemPage = $event"></Pager>
      </div>

      <div v-else class="text-center" style="margin: 50px">
        <i>
          There is no content to display.
        </i>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import ArticleChart from '@/pages/Companies/Companies/Edit/Tabs/Dashboard/Panels/Partnership/ArticleChart'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import StatusLabel from '@/components/StatusLabel'
import Avatar from "../../../../../../../../components/Avatar.vue";
import Pager from "../../../../../../../../components/Lists/Pager.vue";

export default {
  components: {Pager, Avatar, ArticleChart, LoadingSpinner, StatusLabel},

  props: {
    partnership: {},
    showHeader: {default: true},
  },

  data() {
    return {
      activity: null,
      contentItems: null,
      subscriptionPeriods: null,

      contentItemPage: 1,
      loading: true,
    }
  },

  watch: {
    contentItemPage() {
      this.loadContentItems()
    }
  },

  computed: {
    isTrial() {
      return this.subscriptionPeriods.data.length === 0
    },

    startsAt() {
      if (this.isTrial) {
        return null
      }

      return this.subscriptionPeriods.data.find(partnershipPeriod => partnershipPeriod.is_first).starts_at
    },

    endsAt() {
      if (this.isTrial) {
        return null
      }

      return this.subscriptionPeriods.data.find(partnershipPeriod => partnershipPeriod.is_last).ends_at
    },

    currentPrice() {
      if (this.isTrial) {
        return null
      }

      return this.subscriptionPeriods.data.find(partnershipPeriod => partnershipPeriod.is_last).price
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      Promise.all([
        http.get('/api/v2/partnerships/' + this.partnership.id + '/activity'),
        http.get('/api/v2/content-items', {'filter[partnership_id]': this.partnership.id, page_size: 10, page: this.contentItemPage}),
        http.get('/api/v1/subscription-periods?subscription=' + this.partnership.id),
      ]).then(responses => {
        this.activity = responses[0].data.data
        this.contentItems = responses[1].data
        this.subscriptionPeriods = responses[2].data

        this.loading = false
      })
    },

    loadContentItems() {
      http.get('/api/v2/content-items', {'filter[partnership_id]': this.partnership.id, page_size: 10, page: this.contentItemPage})
          .then(response => {
            this.contentItems = response.data
          })
    }
  }
}
</script>
